import React from 'react';
import { Link } from 'react-router-dom';

export interface EmptyStateProps {
  /** What there is none of, e.g. "No tienes cursos todavía." */
  message: string;
  /** Why that might be, or what it means — optional, one line. */
  detail?: string;
  /** The action that changes the situation, when there is one. */
  action?: { label: string; to: string };
}

const box: React.CSSProperties = {
  border: '1px solid #dee2e6',
  borderRadius: 10,
  padding: 16,
  background: '#fff',
};

/**
 * S1.3 — an empty result, stated rather than implied by blank space.
 *
 * Two rules learned from the screens this replaces. An empty state must only be
 * shown once the answer is known — rendering it during a fetch is how "we do not
 * know yet" becomes "you have nothing". And where emptiness has a remedy, it
 * carries the action: the most useful empty state on this product is the one
 * that says a teacher has no availability *and* links to the editor.
 */
export const EmptyState: React.FC<EmptyStateProps> = ({ message, detail, action }) => (
  <div style={box}>
    <p style={{ margin: 0 }}>{message}</p>
    {detail && <p style={{ margin: '8px 0 0', color: '#666', fontSize: 14 }}>{detail}</p>}
    {action && (
      <p style={{ margin: '10px 0 0' }}>
        <Link to={action.to}>{action.label}</Link>
      </p>
    )}
  </div>
);

export default EmptyState;
